import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js";
import digest from '../runtime/digest.js';
import { encode as base64url } from '../runtime/base64url.js';
import { JOSENotSupported, JWKInvalid } from '../util/errors.js';
import { encoder } from '../lib/buffer_utils.js';
import isObject from '../lib/is_object.js';
var check = function check(value, description) {
  if (typeof value !== 'string' || !value) {
    throw new JWKInvalid("".concat(description, " missing or invalid"));
  }
};
export function calculateJwkThumbprint(_x, _x2) {
  return _calculateJwkThumbprint.apply(this, arguments);
}
function _calculateJwkThumbprint() {
  _calculateJwkThumbprint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(jwk, digestAlgorithm) {
    var components, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isObject(jwk)) {
              _context.next = 2;
              break;
            }
            throw new TypeError('JWK must be an object');
          case 2:
            digestAlgorithm !== null && digestAlgorithm !== void 0 ? digestAlgorithm : digestAlgorithm = 'sha256';
            if (!(digestAlgorithm !== 'sha256' && digestAlgorithm !== 'sha384' && digestAlgorithm !== 'sha512')) {
              _context.next = 5;
              break;
            }
            throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
          case 5:
            _context.t0 = jwk.kty;
            _context.next = _context.t0 === 'EC' ? 8 : _context.t0 === 'OKP' ? 13 : _context.t0 === 'RSA' ? 17 : _context.t0 === 'oct' ? 21 : 24;
            break;
          case 8:
            check(jwk.crv, '"crv" (Curve) Parameter');
            check(jwk.x, '"x" (X Coordinate) Parameter');
            check(jwk.y, '"y" (Y Coordinate) Parameter');
            components = {
              crv: jwk.crv,
              kty: jwk.kty,
              x: jwk.x,
              y: jwk.y
            };
            return _context.abrupt("break", 25);
          case 13:
            check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
            check(jwk.x, '"x" (Public Key) Parameter');
            components = {
              crv: jwk.crv,
              kty: jwk.kty,
              x: jwk.x
            };
            return _context.abrupt("break", 25);
          case 17:
            check(jwk.e, '"e" (Exponent) Parameter');
            check(jwk.n, '"n" (Modulus) Parameter');
            components = {
              e: jwk.e,
              kty: jwk.kty,
              n: jwk.n
            };
            return _context.abrupt("break", 25);
          case 21:
            check(jwk.k, '"k" (Key Value) Parameter');
            components = {
              k: jwk.k,
              kty: jwk.kty
            };
            return _context.abrupt("break", 25);
          case 24:
            throw new JOSENotSupported('"kty" (Key Type) Parameter missing or unsupported');
          case 25:
            data = encoder.encode(JSON.stringify(components));
            _context.t1 = base64url;
            _context.next = 29;
            return digest(digestAlgorithm, data);
          case 29:
            _context.t2 = _context.sent;
            return _context.abrupt("return", (0, _context.t1)(_context.t2));
          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _calculateJwkThumbprint.apply(this, arguments);
}
export function calculateJwkThumbprintUri(_x3, _x4) {
  return _calculateJwkThumbprintUri.apply(this, arguments);
}
function _calculateJwkThumbprintUri() {
  _calculateJwkThumbprintUri = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(jwk, digestAlgorithm) {
    var thumbprint;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            digestAlgorithm !== null && digestAlgorithm !== void 0 ? digestAlgorithm : digestAlgorithm = 'sha256';
            _context2.next = 3;
            return calculateJwkThumbprint(jwk, digestAlgorithm);
          case 3:
            thumbprint = _context2.sent;
            return _context2.abrupt("return", "urn:ietf:params:oauth:jwk-thumbprint:sha-".concat(digestAlgorithm.slice(-3), ":").concat(thumbprint));
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _calculateJwkThumbprintUri.apply(this, arguments);
}